import type {
  VehicleFirmwareDeploymentAbortStatus,
  VehicleTelemetryDiagnosticNotice,
} from '@data/fms/vehicle/types';
import type { VehicleAlertType } from '@data/notification/vehicle/types';
import equal from 'fast-deep-equal';

/**
 * FMS Console アクセス時に通知を出すかどうか
 * @param {VehicleTelemetryDiagnosticNotice[]} diagnosticsNotice
 * @return {boolean}
 */
export const getIsFirstDiagnosticsNoticeNotification = (
  diagnosticsNotice: VehicleTelemetryDiagnosticNotice[],
) => diagnosticsNotice.some((diagnosticNotice) => diagnosticNotice.level > 0);

/**
 * 通知すべき差分を返す
 * @param {VehicleTelemetryDiagnosticNotice[]} prevDiagnosticsNotice
 * @param {VehicleTelemetryDiagnosticNotice[]} currentDiagnosticsNotice
 * @returns {VehicleTelemetryDiagnosticNotice[]}
 */
export const getNotifiableDiagnosticsNoticeDiff = (
  prevDiagnosticsNotice: VehicleTelemetryDiagnosticNotice[],
  currentDiagnosticsNotice: VehicleTelemetryDiagnosticNotice[],
) =>
  currentDiagnosticsNotice
    .filter(
      (current) => !prevDiagnosticsNotice.some((prev) => equal(prev, current)),
    )
    .filter((diagnosticNotice) => diagnosticNotice.level > 0);

/**
 * ソフトウェアアップデート中止ステータスの変化を検出し、通知タイプを返す
 */
export const getSoftwareUpdateAbortAlertType = (
  prevAbortStatus: VehicleFirmwareDeploymentAbortStatus | null,
  currentAbortStatus: VehicleFirmwareDeploymentAbortStatus | null,
): VehicleAlertType | null => {
  if (prevAbortStatus === currentAbortStatus) return null;
  if (!currentAbortStatus) return null;
  if (currentAbortStatus === 'success') return null;
  return 'softwareUpdateAbortFailure';
};
